export type SolicitacaoObrigatoriaArtefato =
  | 'agendamento'
  | 'encaminhamento'
  | 'exame'
  | 'fotoceutico'
  | 'medicamento'
  | 'orientacao'
  | 'procedimento'
  | string;

const artigoPorArtefato: Record<string, string> = {
  agendamento: 'deste',
  encaminhamento: 'deste',
  exame: 'deste',
  fotoceutico: 'deste',
  medicamento: 'deste',
  orientacao: 'desta',
  procedimento: 'deste',
};

const nomePorArtefato: Record<string, string> = {
  agendamento: 'agendamento',
  encaminhamento: 'encaminhamento',
  exame: 'exame',
  fotoceutico: 'fotoceutico',
  medicamento: 'medicamento',
  orientacao: 'orientação',
  procedimento: 'procedimento',
};

export const getSolicitacaoObrigatoriaMotivo = (
  artefato: SolicitacaoObrigatoriaArtefato,
  motivo?: string,
) => {
  const trimmedMotivo = motivo?.trim();

  if (trimmedMotivo) return trimmedMotivo;

  const artigo = artigoPorArtefato[artefato] || 'deste';
  const nomeArtefato = nomePorArtefato[artefato] || artefato;

  return `A prescrição ${artigo} ${nomeArtefato} é obrigatória conforme diretrizes da organização. Para uma decisão final, utilize sempre o prontuário eletrônico.`;
};
